import { forwardRef, type ComponentPropsWithoutRef, type ElementRef } from "react";
import { Collapsible as RxCollapsible } from "radix-ui";
import { cn } from "../lib/cn";

export const Collapsible = RxCollapsible.Root;
export const CollapsibleTrigger = RxCollapsible.Trigger;

export const CollapsibleContent = forwardRef<ElementRef<typeof RxCollapsible.Content>, ComponentPropsWithoutRef<typeof RxCollapsible.Content>>(
  ({ className, ...props }, ref) => (
    <RxCollapsible.Content
      ref={ref}
      className={cn("overflow-hidden data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down", className)}
      {...props}
    />
  ),
);
CollapsibleContent.displayName = "CollapsibleContent";
